export const mozillaDocsViewer = "https://mozilla.github.io/pdf.js/web/viewer.html";
export const googleDocsViewer = "https://docs.google.com/gview";

// All status values defined in ONE place
export const APP_STATUS = {
  UNDERWRITING: "Underwriting In-Progress",
  REVIEW_IN_PROGRESS: "Review In-Progress",
  SUBMISSION_PENDING: "Submission Pending",
  SANCTIONED: "Sanctioned",
  DISBURSED: "Disbursed",
  ELIGIBILITY_FAILED: "Eligibility Failed",
  APPLICATION_REJECTED: "Application Rejected",
  APPLICATION_CLOSED: "Application Closed",
  DECLINED_BY_CREDIT: "Declined by Credit",
};

// Messages Based on Application Status for Loan Details Card
const APPLICATION_STATUS_MESSAGES = {
  UNDERWRITING: "Your application is currently under underwriting review.",
  REVIEW_IN_PROGRESS:
    "Your application is currently being reviewed by our team.",
  SUBMISSION_PENDING:
    "Your application has been submitted and is pending review.",
  SANCTIONED: "Your Sanctioned Details",
  DISBURSED:
    "Congratulations your Loan is disbursed. Please go to Loans Section for details.",
  ELIGIBILITY_FAILED:
    "Thanks for applying, while we don't have an instant match, our team is on it. Our experts will reach out soon to help you.",
  APPLICATION_REJECTED:
    "Thanks for applying. After reviewing your details, we’re unable to proceed with your loan at this time as it doesn't meet our current criteria.",
  APPLICATION_CLOSED:
    "Your application is now closed. We appreciate your interest in Avanse and hope to work with you again soon!",
  DECLINED_BY_CREDIT:
    "Thanks for applying. After reviewing your details, we’re unable to proceed with your loan at this time as it doesn't meet our current criteria.",
} satisfies Record<keyof typeof APP_STATUS, string>;

const PROVISIONAL_MESSAGES = {
  // Provisional/UX messages (not tied 1:1 with `APP_STATUS`)
  PROVISIONAL_OFFER: "Your Provisional offer details",
  NO_PROVISIONAL_OFFER:
    "Thank you for completing the details. While we cannot provide an instant offer right now, your application is still being considered. A Sales Manager will review your profile and contact you shortly to discuss available financing options.",
  PROVISIONAL_LOCKED:
    "This section will be unlocked once the case is Sanctioned",
  COMPLETE_DETAILS: "Complete Applicant details to unlock Provisional Offer",
} as const;

export const STATUS_MESSAGES = {
  // These keys intentionally mirror `APP_STATUS` so callers can do:
  // `STATUS_MESSAGES[APP_STATUS_KEY]` without returning `undefined`.
  ...APPLICATION_STATUS_MESSAGES,
  ...PROVISIONAL_MESSAGES,
};